export const dataTestIds = {
	cardColorOption:
		'software-board-settings-color-picker.ui.color-picker.color-palette-menu.color-card.color-card-option',
	cardColorButtonContent:
		'software-board-settings-color-picker.ui.color-picker.color-card-button.color-card-button-content',
	colorPaletteMenuWrapper:
		'software-board-settings-color-picker.ui.color-picker.color-palette-menu.color-palette-menu-wrapper',
} as const;
